export default __webpack_public_path__ + "static/media/star-icon-outline.556d1b3b.svg";